var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgText = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "type-20px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4585 3.3335C2.4585 2.85025 2.85025 2.4585 3.3335 2.4585H16.6668C17.1501 2.4585 17.5418 2.85025 17.5418 3.3335V5.8335C17.5418 6.31675 17.1501 6.7085 16.6668 6.7085C16.1836 6.7085 15.7918 6.31675 15.7918 5.8335V4.2085H10.8752V15.7918H12.5002C12.9834 15.7918 13.3752 16.1836 13.3752 16.6668C13.3752 17.1501 12.9834 17.5418 12.5002 17.5418H7.50016C7.01691 17.5418 6.62516 17.1501 6.62516 16.6668C6.62516 16.1836 7.01691 15.7918 7.50016 15.7918H9.12516V4.2085H4.2085V5.8335C4.2085 6.31675 3.81675 6.7085 3.3335 6.7085C2.85025 6.7085 2.4585 6.31675 2.4585 5.8335V3.3335Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgText, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/text.b7fe4cd8.svg";
export { ForwardRef as ReactComponent };